<template>
  <v-container
    fluid
    class="pt-0 px-1"
  >
    <v-row no-gutters>
      <v-col class="pa-0">
        <v-treeview
          ref="treeview"
          class="catalog-tree text-body-2"
          :items="tree"
          :search="search"
          :filter="filter"
          :open.sync="opened"
          open-all
          return-object
          dense
          activatable
          hoverable
          open-on-click
        >
          <template v-slot:label="{ item, leaf }">
            <span
              v-if="!leaf"
              class="catalog-tree-node catalog-tree-node-branch secondary--text text--lighten-4"
            >
              {{ item.name }}
            </span>
            <v-container
              v-else
              class="catalog-tree-node catalog-tree-node-leaf pa-0"
              :class="
                'catalog-tree-node catalog-tree-node-' +
                  (leaf ? 'leaf' : 'branch')
              "
              fluid
            >
              <v-row no-gutters>
                <v-col class="d-flex flex-grow-1 text-truncate">
                  <span
                    :class="
                      'catalog-tree-node catalog-tree-node-' +
                        (leaf ? 'leaf' : 'branch')
                    "
                    @dblclick="addEntry(item.data)"
                  >
                    <v-icon
                      v-if="item.data && item.data.type"
                      :color="
                        getEntryStyle(item.data.type, { lighten: 2 }).color
                      "
                      left
                    >{{
                      getEntryStyle(item.data.type, { outline: true }).icon
                    }}</v-icon>
                    {{ item.name }}
                  </span>
                </v-col>
                <v-col class="align-end flex-grow-0">
                  <v-btn
                    v-if="!item.data.code"
                    icon
                    :color="getEntryStyle(item.data.type).color"
                    class="mr-2"
                    x-small
                    @click="addEntry(item.data)"
                  >
                    <v-icon>mdi-chevron-double-right</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    text
                    :color="getEntryStyle(item.data.type).color"
                    class="font-weight-bold"
                    small
                    outlined
                    @click="addEntry(item.data)"
                  >
                    {{ item.data.code
                    }}<v-icon right>
                      mdi-chevron-double-right
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-treeview>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

import Catalog from '@/models/catalog'
import { getEntryStyle } from '@/components/utils'

export default {
	name: 'CatalogTree',

	props: {
		catalog: {
			type: Catalog,
			required: true,
		},
		search: {
			type: String,
			default: null,
		},
	},
	data: () => ({ tree: [], opened: [] }),
	computed: {
		filter: function() {
			// return (item, search, textKey) => item[textKey].indexOf(search) > -1
			return (item, search) => {
				return item.data
					? item.data.label.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
							item.data.code.toLowerCase().indexOf(search.toLowerCase()) > -1
					: false
			}
		},
	},
	watch: {
		catalog: function() {
			this.makeTree()
		},
	},
	methods: {
		...mapActions('journal', ['addEntry']),
		makeTree() {
			if (!this.catalog.imported) {
				this.tree = []
				return
			}
			var tree = []
			var count = 0
			for (const e of this.catalog.entries) {
				// enrich data with a unique id and custom label
				const enriched = {
					name: e.label,
					data: e,
				}
				// add enriched data to the tree, recursively creating the parents if needed
				count = this.addTreeNode(tree, {
					count,
					subcats: [...e.cats],
					enriched,
				})
			}
			// update comp data
			this.tree = tree
			// open all nodes
			this.$nextTick(() => {
				this.$refs.treeview.updateAll(true)
			})
		},
		addTreeNode(root, { count, subcats, enriched }) {
			if (subcats.length === 0) {
				count++
				root.push({
					id: `${count}-leaf`,
					...enriched,
				})
				return count
			}
			var subcat = subcats.shift()
			// find pos of existing cat
			var pos = root.findIndex(e => e.name === subcat)
			// insert first if does not exist
			if (pos === -1) {
				count++
				root.push({ id: `${count}-branch`, name: subcat, children: [] })
				pos = root.length - 1
			}
			// call recursively
			root = root[pos].children
			count = this.addTreeNode(root, { count, subcats, enriched })
			return count
		},
		getEntryStyle, // in order to be used in template
	},
}
</script>

<style lang="scss">
.catalog-tree {
	// max-height: calc(100% - 48px - 1px); // minus toolbar and divider
	.v-treeview-node__root {
		min-height: 24px !important;
		padding: 0;
		.catalog-tree-node-leaf {
			line-height: 36px !important;
		}
	}
	.v-treeview-node__level {
		width: 12px; // reduce indentation
	}
}
</style>
